import cx from "classnames";
import { ReactComponent as ClearIcon } from "assets/icons/clear.svg";
import { ReactComponent as SearchIcon } from "assets/icons/icon-search.svg";
import { Input } from "components/Input";
import { PageMessage } from "components/PageMessage";
import { useIsMobile } from "hooks";
import { truncate } from "lodash";
import React, { type PropsWithChildren } from "react";
import { ReactComponent as EmptyIcon } from "./assets/empty.svg";

import * as styles from "./MarketsFilter.module.scss";

type MarketSearchInputProps = {
  value: string;
  onValueChange: (value: string) => void;
  onValueReset: () => void;
  hasResults: boolean;
  className?: string;
};

const reduceLengthWhen = (isMobile: boolean) => {
  // default is 30, slightly more than 50% reduction
  // to handle the smaller screens
  return isMobile ? 12 : 30;
};

const truncated = (value: string, isMobile: boolean) =>
  truncate(value, { length: reduceLengthWhen(isMobile) });

export const MarketsFilter = ({
  value,
  onValueChange,
  onValueReset,
  hasResults,
  children,
  className,
}: PropsWithChildren<MarketSearchInputProps>) => {
  const isMobile = useIsMobile();

  return (
    <>
      <Input
        type="text"
        containerClassName={cx(styles.input, className)}
        placeholder="Search Markets"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        prefixIcon={<SearchIcon />}
        icon={
          value && (
            <span onClick={onValueReset} className={styles.clearIcon}>
              <ClearIcon />
            </span>
          )
        }
      />

      {hasResults ? (
        <>{children}</>
      ) : value ? (
        <PageMessage
          image={<EmptyIcon width="251" />}
          title={`No results for "${truncated(value, isMobile)}"`}
          subTitle={"Try a different keyword or spelling"}
        />
      ) : null}
    </>
  );
};
